
<div>
  <canvas baseChart 
    [data]="doughnutChartData"
    [labels]="doughnutChartLabels"
    [colors]="doughnutcolors"
    [options]="options"
    [chartType]="doughnutChartType">
  </canvas>
  <div class="LC_TR_QTC">
    <div class="LC_TR_QC">
      {{donchd.count}}
    </div>
  </div>
</div>